// @ts-ignore immer intentionally exposes freeze but it's missing from the type definitions
import { freeze as immerFreeze } from 'immer';

interface freeze {
  <T>(obj: T, deep?: boolean): T;
  <T>(obj: any, deep: boolean): T;
}

export const freeze = immerFreeze as freeze;
